<template>
  <div class="delivery-address-main-container">
    <div style="display: flex; margin-bottom:20px">
      <t-checkbox
        style="margin-bottom:0"
        v-model="billing.value"
        name=" billing address"
        :changeAction="changeBilling"
        @click="toggleCheckox()"
      />
      <span style="margin-left: 10px; margin-top: 3px" class="same-as-billing">
        {{$translation($websiteText().checkout_generals_shipping_same_as_billing)}}
      </span>
    </div>
    
      <div
        v-if="this.$store.getters.isAuthenticated == true"
        class="info-address-item"
      >
        <div class="title-address-info">{{$translation($websiteText().checkout_generals_use_saved_details)}}</div>
        <t-input-select
          name="default_shipping_address"
          :filter="true"
          v-model="defaultShippingAddress"
          :options="shippingAddresses"
          optionLabel="address"
          optionLabel1="country"
          filterLabel="address"
          optionValue="id"
          placeholder="Select delivery Address"
          :changeAction="updateSelectedShipping"
          :filterFields="['address']"
        ></t-input-select>
      </div>
      <shipping-address-form
        :data_="selectedShippingAddress"
        :showSubmit="false"
        @validated="onValidated(true)"
        :disabled = "billing.value||$store.getters.status_id==2"
      ></shipping-address-form>
    
  </div>
</template>
<script>
import TButton from "../../../../common/components/buttons/TButton.vue";
import TCheckbox from "../../../../common/components/controls/TCheckbox.vue";
import TInputSelect from "../../../../common/components/input-text/TInputSelect.vue";
import ShippingAddressForm from "../../../userdashboard/components/profile/ShippingAddressForm.vue";
import store from "../../../../store";
import { reactive } from "@vue/reactivity";
import deliveryMethode from "./DeliveryMethode";
import { CREATE_SHIPPING_ADDRESS, GET_SHIPPING_ADDRESSES, UPDATE_SHIPPING_ADDRESS } from "../../../userdashboard/store/customer/actions";
import BindingHelper from "../../../../common/helpers/BindingHelper";


import { 
  UPDATE_ORDER_DELIVERY_ADDRESS,
  EDIT_ALL_ORDER_DETAILS,
  GET_PRICE_BREAKDOWN
} from "../../store/actions";

export default {
  components: {
    TInputSelect,
    TCheckbox,
    ShippingAddressForm,
  },
  data() {
    return {
      validated: false,
      shippingAddresses: [],
    };
  },
  watch: {
    selectedShippingAddress: {
      handler(value) {
        this.$store.commit(UPDATE_ORDER_DELIVERY_ADDRESS, value);
     
        
      },
      deep: true,
    },
  },
  setup() {
    let billing = reactive({
      value: false,
    });
    const defaultShippingAddress = undefined;
    const selectedShippingAddress = reactive(
      store.getters.orderDeliveryAddress
    );

    store.dispatch(GET_SHIPPING_ADDRESSES).then((response) => {
      if(response.length)
        BindingHelper.map(selectedShippingAddress, response[0]);
    });

    const updateSelectedShipping = function (value) {
      store.getters.shippingAddresses.forEach(function (item) {
        if (item.id == value&&item.id!='id') {
          BindingHelper.map(selectedShippingAddress, item);
        }
      });
    };

    const changeBilling = (value) => {
      if (value == true) {
        var orderShippingAddressId = selectedShippingAddress.id
        BindingHelper.map( 
          selectedShippingAddress,
          store.getters.orderBillingAddress,
          false
        );
        selectedShippingAddress.id = orderShippingAddressId
        shippingValidated.value = true;
      } else {
        shippingValidated.value = false;
        BindingHelper.map(selectedShippingAddress, {}, false);
      }
    };

    const goToDeliveryMethode = () => {
      if (shippingValidated.value == true) {
         store.dispatch(EDIT_ALL_ORDER_DETAILS).then(
          ()=>{
              store.commit("deliveryAddressDisplayActive", false);
              store.commit("deliveryMethodeDisplayActive", true);
              store.commit("checkoutActiveComponent", deliveryMethode);
              store.commit("deliveryMethodeDisplay", false);
              store.commit("displaySummery", true);
              store.commit("setStepperDisplays", [1, 1, 1, 1, 0, 0]);
            }
          )
      }
    };

    let shippingValidated = reactive({
      value: false,
    });

    let onValidated = (value) => {
      shippingValidated.value = value;    
    };

    return {
      defaultShippingAddress,
      updateSelectedShipping,
      selectedShippingAddress,
      goToDeliveryMethode,
      onValidated,
      shippingValidated,
      changeBilling,
      billing,
    };
  },
  created() {
    var that = this;
    if (this.$store.getters.isAuthenticated == true) {
      this.$store
        .dispatch(GET_SHIPPING_ADDRESSES, this.$store.getters.customer.id)
        .then((resp) => {
          that.shippingAddresses = resp;
        });
    }

    window.addEventListener('keyup',function(){
      if(that.billing.value)
      {
        that.changeBilling(true)
      }
    })
  },
  methods: {
    changeValue(value) {
    },

    toggleCheckox()
    {
      this.billing.value = !this.billing.value
    }
  },
};
</script>
<style lang="scss">

.same-as-billing{
  @include f-button;
  color:$light-black;
}
.btn-next {
  margin-top: 50px !important;
}
.p-input-filled .p-inputtext {
  background-image: unset !important;
}
@import "../../style/DeliveryAddress.scss";

.p-field-checkbox{
  margin-bottom: 0;
}
</style>
